import { Camera } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface ARButtonProps {
  onClick: () => void;
  variant?: "primary" | "outline" | "compact";
  className?: string;
}

const ARButton = ({ onClick, variant = "outline", className = "" }: ARButtonProps) => {
  const isMobile = useIsMobile();
  if (!isMobile) return null;

  const base = "inline-flex items-center justify-center gap-2 font-semibold transition-all active:scale-[0.97]";
  const styles =
    variant === "primary"
      ? "w-full rounded-2xl bg-foreground text-background py-4 text-[14px] shadow-lg"
      : variant === "compact"
      ? "rounded-full bg-card border border-border px-4 py-2.5 text-[12px] text-foreground"
      : "w-full rounded-2xl border border-border bg-card text-foreground py-4 text-[14px]";

  return (
    <button onClick={onClick} className={`${base} ${styles} ${className}`}>
      <Camera className="h-4 w-4" />
      Посмотреть на своём окне
    </button>
  );
};

export default ARButton;
